import { take, fork, all } from 'redux-saga/effects';
import { apiTask } from '../app/sagas';
import { api } from '../app/api';
import * as actions from './unitsActions';

export const getInfo = apiTask(actions.GET_INFO, api.post, '/pi/getInfo.php');

export function* watchGetInfo() {
  while (true) {
    const { payload } = yield take(actions.GET_INFO);
    yield fork(getInfo, payload);
  }
}

// Root module saga
export function* sagas() {
  // yield all([fork(watchGetInfo)]);
  yield all();
}
